<template>
    <v-loading v-if="loading" />
    <div v-else>
        <div style="display: flex;justify-content: space-between">
            <h1 class="h1">Основная информация {{ category === "courses" ? "курса" : "обучения" }}</h1>
            <v-button style="height: 48px;" class="desktop" @click="uploadCourse">
                {{ btnText }}
            </v-button>
        </div>
        <div class="about-info-list">
            <!--<div class="about-info-menu">
                <div
                    class="about-course-menu-item"
                    v-for="({ title, route }, index) of courseMainInfo"
                    :key="index"
                    :class="{ 'is-active': $route.name === route }"
                    @click="$router.replace({ name: route })"
                >
                    <span class="about-course-menu-item_name">{{ title }}</span>
                    <v-icon src="arrow-right" class="teacher-course-detail-icon" />
                </div>
            </div>-->
            <v-tabs :options="tabs" v-model="tab" />
            <div class="about-info-detail">
                <keep-alive>
                    <router-view
                        v-if="!loading"
                        :tags="courseTags"
                        :api-data="data"
                        @updateData="updateData"
                        style="max-width: 800px;width: 100%;"
                    />
                </keep-alive>
                <div class="bottom-button tablet">
                    <v-button style="height: 48px;" @click="uploadCourse">
                        {{ btnText }}
                    </v-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VButton from "../../../../../common/components/VButton";
import { api } from "../../../services";

const TABS = [
    {
        label: "Оглавление",
        value: "editor-course-header",
        disable: false
    },
    {
        label: "Описание",
        value: "editor-course-content",
        disable: false
    }
    /*       {
                                       title: "Сообщение курса",
                                       route: "editor-course-message",
                                       category: ["courses"]
                                   }*/
];

export default {
    name: "CourseEditorInfo",
    props: {
        id: {},
        category: {},
        slug: {}
    },
    components: {
        VButton
    },
    data() {
        return {
            TABS,
            tabs: [],
            tab: this.$route.name,
            loading: false,
            data: null,
            formData: null,
            courseTags: {},
            btnText: "",
            errors: {}
        };
    },
    created() {
        this.getCourse();
    },
    /*  async beforeRouteLeave(to, from, next) {
                        await this.openModal("Submit").then(() => {
                            return;
                        });
                        next();
                    },*/
    mounted() {
        this.prepareTabs();
        this.prepareBtn();
        if (!TABS.find(t => t.value === this.$route.name)) {
            this.tab = TABS[0].value;
        }
    },
    watch: {
        tab(name) {
            this.$router.replace({ name });
        }
    },
    computed: {},
    methods: {
        getCourse() {
            if (this.id !== "creating") {
                this.loading = true;
                api.editor
                    .getCourseById(this.id)
                    .then(data => {
                        this.data = {
                            ...data.general_information,
                            audience: data?.audience,
                            requirements: data?.requirements,
                            targets: data?.targets
                        };
                    })
                    .then(() => {
                        this.fetchTags().finally(() => (this.loading = false));
                    });
            } else {
                this.loading = true;
                this.fetchTags().finally(() => (this.loading = false));
            }
        },
        fetchTags() {
            return api.editor.getCourseTags().then(tagsData => {
                const { categories, levels, languages } = tagsData;
                const tags = { categories, levels, languages };
                for (let tag in tags) {
                    this.courseTags[tag] = tags[tag].map(item => ({ label: item.name, value: item.id }));
                }
            });
        },
        prepareBtn() {
            let text;
            if (this.id !== "creating") {
                text = "Сохранить";
            } else if (this.category === "courses") {
                text = "Создать курс";
            } else {
                text = "Создать обучение";
            }
            this.btnText = text;
        },
        prepareTabs() {
            if (this.category === "learning") {
                this.tabs = [TABS[0]];
            } else {
                this.tabs = TABS;
                if (this.id === "creating") {
                    this.tabs[1].disable = true;
                } else {
                    this.tabs[1].disable = false;
                }
            }
        },
        updateData(data) {
            this.formData = {
                ...this.formData,
                ...data
            };
        },
        uploadCourse() {
            if (this.id === "creating") {
                this.createCourse();
            } else {
                this.updateCourse();
            }
        },
        updateCourse() {
            api.editor
                .updateCourse(this.id, this.formData)
                .then(() => {
                    let notifyText = this.category === "courses" ? "Курс обновлен" : "Обучение обновлено";
                    this.notify({ title: "Успех", text: `${notifyText}` });
                })
                .catch(({ data }) => {
                    Object.entries(data.errors).forEach(([key, value]) => {
                        this.errors[key.split(".")[0]] = value[0];
                    });
                    this.notify({ title: "Ошибка", text: "Не все поля заполнены", type: "error" });
                });
        },
        createCourse() {
            // this.loading = true;
            let slug = this.slug === "personal" ? "course" : this.slug;

            api.editor
                .createCourse(slug, this.formData)
                .then(data => {
                    this.$router.replace({
                        name: "editor-menu",
                        params: {
                            category: this.category,
                            slug: this.slug,
                            id: data.general_information.id
                        }
                    });
                })
                .finally(() => (this.loading = false));
        },
        open(item) {
            this.components = item;
        }
    }
};
</script>

<style lang="scss" scoped>
.about-info-menu {
    margin-right: 32px;
}

.about-info-detail {
    padding-bottom: 50px;
    .bottom-button {
        margin-top: 50px;
        .v-button {
            margin: 0 auto;
            max-width: 500px;
            width: 100%;
        }
    }
}

.about-info-list_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.about-info-list_btn {
    display: none;
    @media (max-width: 650px) {
        display: flex;
        cursor: pointer;
        align-items: center;
    }
}

.not_valid {
    border: 1px solid red;
}

.about-course-menu-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 252px;
    height: 56px;
    background: #f5f7fa;
    border-radius: 4px;
    border: 2px solid transparent;
    padding: 0 8px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: border 0.3s ease;

    &.is-active {
        background: rgba(#fff, 0.3);
        border: 2px solid #ffc107;
    }

    &_name {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;

        color: #1d2228;
    }
}
</style>
